import { gql } from '@apollo/client';

export const ALL_CASH_LIMIT_UPLOAD_EVENTS_QUERY_NAME = 'AllCashLimitUploadEvents';
export const ALL_CASH_LIMIT_UPLOAD_EVENTS = gql`
    query ${ALL_CASH_LIMIT_UPLOAD_EVENTS_QUERY_NAME}(
        $page: Int, 
        $perPage: Int,
        $sortKey: String,
        $sortDirection: String,
        $valueMapping: Map_String_List_MappedValueScalar,
    ) {
        allCashLimitUploadEvents(
            page: $page, 
            perPage: $perPage,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
            valueMapping: $valueMapping,
        ) {
            totalCount
            models {
                id
                uploadTimestamp
                fileName
                exportTimestamp
                uploader {
                    racf
                    userCode
                    name
                }
                outcome
                cashLimitConfirmationFileId
            }
        }
    }
`;
